module.exports = __webpack_public_path__ + "static/media/technologyWhite.a5e4a032.svg";